import { render, staticRenderFns } from "./UniversalModal.vue?vue&type=template&id=e498ddda&scoped=true"
import script from "./UniversalModal.vue?vue&type=script&lang=ts"
export * from "./UniversalModal.vue?vue&type=script&lang=ts"
import style0 from "./UniversalModal.vue?vue&type=style&index=0&id=e498ddda&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e498ddda",
  null
  
)

export default component.exports